import gsap from "gsap";

window.addEventListener('load', function () {
    let button = document.querySelector('#js-open-nominations');

    if (button) {
        button.addEventListener('click', () => {
            let nominationsBlock = this.document.querySelector('#js-block-nominations');

            if(!nominationsBlock.classList.contains('upsd-nominations__grid_hidden')) {
                return;
            }

            for(let nm of this.document.querySelectorAll('.js-grid-firts .upsd-nomination')) {
                nm.classList.add('upsd-nominations__item_b')
            }

            gsap.fromTo(
                nominationsBlock,
                { maxHeight: '0px', opacity: 0 },
                {
                    maxHeight: '2000px', opacity: 1,
                    onStart: () => {
                        nominationsBlock.classList.remove('upsd-nominations__grid_hidden');
                        button.closest('div').style.display = 'none';
                    }
                }
            );

        });
    }


});